import { object, string, ref } from "yup";

const ValidationSchema = object().shape({
  memberId: string().required("MemberId is required."),
  password: string()
    .required("Password is required.")
    .min(8, "Password should be at least 8 characters long.")
    .matches(
      /[a-zA-Z]/,
      "Password requires one uppercase or lowercase letter (A–Z, a–z)",
    )
    .matches(
      /^(?=(.*[\d@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]){2,})/,
      "Password requires at least two numbers or special characters. (e.g. $#%)",
    ),
  confirmPassword: string()
    .oneOf([ref("password"), null], "Passwords do not match.")
    .required("Confirm password is required."),
});

export default ValidationSchema;
